import * as Constants from '../../constants';
import { Property, Resource } from '../../types/DataExplorer';
import { DataTreeNode } from '../../types/Tree';
import {
  AddNode,
  AddNodeFailed,
  AddNodeSuccess,
  AddProperty,
  AddPropertyFailed,
  AddPropertySuccess,
  CollapseNode,
  DeleteNode,
  DeleteNodeFailed,
  DeleteNodeSuccess,
  EditNode,
  EditNodeFailed,
  EditNodeSuccess,
  ExpandNode,
  GetChildNodes,
  GetChildNodesFailed,
  GetChildNodesSuccess,
  GetNodeProperties,
  GetNodePropertiesFailed,
  GetNodePropertiesSuccess,
  GetRootNodes,
  GetRootNodesFailed,
  GetRootNodesSuccess,
  SelectNode
} from './ActionTypes';

export const getRootNodes = (): GetRootNodes => ({
  type: Constants.GET_ROOT_NODES
});

export const getRootNodesSuccess = (
  rootNodes: Resource[]
): GetRootNodesSuccess => ({
  type: Constants.GET_ROOT_NODES_SUCCESS,
  payload: { rootNodes }
});

export const getRootNodesFailed = (): GetRootNodesFailed => ({
  type: Constants.GET_ROOT_NODES_FAILED
});

export const getChildNodes = (vmid: string): GetChildNodes => ({
  type: Constants.GET_CHILD_NODES,
  payload: { vmid }
});

export const getChildNodesSuccess = (
  parentVmid: string,
  childNodes: Resource[]
): GetChildNodesSuccess => ({
  type: Constants.GET_CHILD_NODES_SUCCESS,
  payload: { parentVmid, childNodes }
});

export const getChildNodesFailed = (): GetChildNodesFailed => ({
  type: Constants.GET_CHILD_NODES_FAILED
});

export const expandNode = (vmid: string): ExpandNode => ({
  type: Constants.EXPAND_NODE,
  payload: { vmid }
});

export const collapseNode = (vmid: string): CollapseNode => ({
  type: Constants.COLLAPSE_NODE,
  payload: { vmid }
});

export const selectNode = (node: DataTreeNode): SelectNode => ({
  type: Constants.SELECT_NODE,
  payload: { node }
});

export const addNode = (node: Resource): AddNode => ({
  type: Constants.ADD_NODE,
  payload: { node }
});

export const addNodeSuccess = (node: Resource): AddNodeSuccess => ({
  type: Constants.ADD_NODE_SUCCESS,
  payload: { node }
});

export const addNodeFailed = (): AddNodeFailed => ({
  type: Constants.ADD_NODE_FAILED
});

export const editNode = (node: Resource): EditNode => ({
  type: Constants.EDIT_NODE,
  payload: { node }
});

export const editNodeSuccess = (node: Resource): EditNodeSuccess => ({
  type: Constants.EDIT_NODE_SUCCESS,
  payload: { node }
});

export const editNodeFailed = (): EditNodeFailed => ({
  type: Constants.EDIT_NODE_FAILED
});

export const deleteNode = (vmid: string): DeleteNode => ({
  type: Constants.DELETE_NODE,
  payload: { vmid }
});

export const deleteNodeSuccess = (vmid: string): DeleteNodeSuccess => ({
  type: Constants.DELETE_NODE_SUCCESS,
  payload: { vmid }
});

export const deleteNodeFailed = (): DeleteNodeFailed => ({
  type: Constants.DELETE_NODE_FAILED
});

export const getNodeProperties = (vmid: string): GetNodeProperties => ({
  type: Constants.GET_NODE_PROPERTIES,
  payload: { vmid }
});

export const getNodePropertiesSuccess = (
  properties: Property[]
): GetNodePropertiesSuccess => ({
  type: Constants.GET_NODE_PROPERTIES_SUCCESS,
  payload: { properties }
});

export const getNodePropertiesFailed = (): GetNodePropertiesFailed => ({
  type: Constants.GET_NODE_PROPERTIES_FAILED
});

export const addProperty = (property: Property): AddProperty => ({
  type: Constants.ADD_PROPERTY,
  payload: { property }
});

export const addPropertySuccess = (property: Property): AddPropertySuccess => ({
  type: Constants.ADD_PROPERTY_SUCCESS,
  payload: { property }
});

export const addPropertyFailed = (): AddPropertyFailed => ({
  type: Constants.ADD_PROPERTY_FAILED
});
